import { querytemplateApi } from '../../apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../organisation/useMe';

export const useCreateQueryTemplate = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();

  return useMutation({
    mutationFn: ({ name, content }: { name: string; content: string }) => {
      return querytemplateApi.createQueryTemplate({
        apiQueryTemplate: {
          name,
          content,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['query_templates', currentOrganisation?.id],
      });
    },
  });
};

export const useUpdateQueryTemplate = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();

  return useMutation({
    mutationFn: ({ id, name, content }: { id: number; name: string; content: string }) => {
      return querytemplateApi.updateQueryTemplate({
        id,
        apiQueryTemplate: {
          name,
          content,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['query_templates', currentOrganisation?.id],
      });
    },
  });
};

export const useDeleteQueryTemplate = () => {
  const queryClient = useQueryClient();
  const { currentOrganisation } = useMe();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => {
      return querytemplateApi.deleteQueryTemplate({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['query_templates', currentOrganisation?.id],
      });
    },
  });
};
